import React from "react";
import { joinClassnames } from "utils/map-modifier";
import "./index.scss";

interface GiftListProps {
  data?: string;
  hasIcon?: boolean;
  smallSpacingBetweenItem?: boolean;
}

const GiftList: React.FC<GiftListProps> = ({
  data,
  hasIcon,
  smallSpacingBetweenItem,
}) => {
  return data ? (
    <div
      className={joinClassnames(
        "m-cashlist-cms",
        hasIcon && "has-icon",
        smallSpacingBetweenItem && "small-spacing-between-item",
      )}
      dangerouslySetInnerHTML={{ __html: data }}
    />
  ) : null;
};

GiftList.defaultProps = {};

export default GiftList;
